import RestService from '../services/rest';

// GET
async function getPageLayout(pageLayout) {
  return RestService.getAuthenticated('pageLayout/detail', pageLayout);
}

// PUT
async function updatePageLayout(pageLayout) {
  return RestService.putAuthenticated('pageLayout/update', pageLayout);
}

export default {
  getPageLayout,
  updatePageLayout,
};
